export default __webpack_public_path__ + "static/media/FAQ.504b7752.pdf";